import React from 'react';
import Products from './components/products/productsContainer';
import ErrorBoundary from './components/errorBoundary/errorBoundary';
import listerAppStyles from './listerApp.module.pcss';
import FadeOverlay from './components/overlays/fadeOverlay';
import PaginatedResults from './components/pagination/paginatedResults';
import useAttraqtTrackerViewEvent from './hooks/useAttraqtTrackerViewEvent';
import FacetsMenu from './components/facets/facetsMenu';
import { trackListView } from '../../analytics';

function ListerApp(): React.ReactElement {
  useAttraqtTrackerViewEvent();

  React.useEffect(() => {
    trackListView();
  }, []);

  return (
    <div className={listerAppStyles.lister}>
      <ErrorBoundary>
        <FacetsMenu />
        <main className={listerAppStyles['lister__listing']}>
          <PaginatedResults>
            <Products />
          </PaginatedResults>
        </main>
        <FadeOverlay />
      </ErrorBoundary>
    </div>
  );
}

export default ListerApp;
